import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Amplify is configured in services/amplifyApi.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);